var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/TrashWithCross.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const TrashWithCross = ({
  color = '#4C5ECF',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "12",
  height: "14",
  viewBox: "0 0 12 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("path", {
    d: "M1.5 12.25C1.5 13.075 2.175 13.75 3 13.75H9C9.825 13.75 10.5 13.075 10.5 12.25V4.75C10.5 3.925 9.825 3.25 9 3.25H3C2.175 3.25 1.5 3.925 1.5 4.75V12.25ZM3.8775 6.3775C4.17 6.085 4.6425 6.085 4.935 6.3775L6 7.4425L7.065 6.3775C7.3575 6.085 7.83 6.085 8.1225 6.3775C8.415 6.67 8.415 7.1425 8.1225 7.435L7.0575 8.5L8.1225 9.565C8.415 9.8575 8.415 10.33 8.1225 10.6225C7.83 10.915 7.3575 10.915 7.065 10.6225L6 9.5575L4.935 10.6225C4.6425 10.915 4.17 10.915 3.8775 10.6225C3.585 10.33 3.585 9.8575 3.8775 9.565L4.9425 8.5L3.8775 7.435C3.585 7.15 3.585 6.67 3.8775 6.3775ZM8.625 1L8.0925 0.4675C7.9575 0.3325 7.7625 0.25 7.5675 0.25H4.4325C4.2375 0.25 4.0425 0.3325 3.9075 0.4675L3.375 1H1.5C1.0875 1 0.75 1.3375 0.75 1.75C0.75 2.1625 1.0875 2.5 1.5 2.5H10.5C10.9125 2.5 11.25 2.1625 11.25 1.75C11.25 1.3375 10.9125 1 10.5 1H8.625Z",
    fill: color
  })
});